import PricingTable from './pricing-table-view';

export default PricingTable;
